var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"un"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.unPublish,"alt":""}}),_c('p',[_vm._v(_vm._s(!_vm.unPublishType?'该活动已删除!':'活动暂未发布，当前仅供浏览'))])]),(_vm.unPublishType)?_c('van-button',{attrs:{"round":"","type":"primary"},on:{"click":_vm.next}},[_vm._v("我知道了")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }